class UpdateAiProvider {
	constructor(
		public readonly accountId: number,
		public readonly providerId: number,
		public readonly label: string,
		public readonly kind: string,
		public readonly baseUrl: string,
		public readonly apiVersion: string | null,
		public readonly apiKey: string | null,
		public readonly isPlatformCredential: boolean,
	) {
		Object.freeze(this);
	}

	// `accountId` and `providerId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		const body: Record<string, unknown> = {
			label: this.label,
			kind: this.kind,
			baseUrl: this.baseUrl,
			apiVersion: this.apiVersion,
			isPlatformCredential: this.isPlatformCredential,
		};

		// An omitted key means "keep the one already registered": the front never receives the key, so
		// it cannot echo it back. An empty string would overwrite the registered key with nothing.
		if (this.apiKey !== null && this.apiKey !== '') {
			body.apiKey = this.apiKey;
		}

		return body;
	}
}

export default UpdateAiProvider;
